export default __webpack_public_path__ + "static/6845-29c2fced62315eb93e8bef593b9c7271.jpg";